import * as d3 from "d3";
import {
    colonAnnotation,
    contextMenu,
    createAxis, createTooltip,
    // downloadData,
     generateDownloadData,
    numberFormat,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam) {
    var size = chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = chart.axisLabelFontSize + "px"
    //var tempVar = chart.tempVar
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:",chart, vizName,filterParam)

    /*
    select va1 as dim1_name, vm1 as metric1, vm2 as metric2, vm3 as metric3, vm4 as metric4
    from fw_ods.fw_ods_viz_data_generic
    where viztype_name= 'Waterfall' and client_id=10 order by va1;
     */

    //scales
    var x1Scale = createAxis(chart.x1D3ScaleType).rangeRound([0, chart.width]).padding(0.1)
    var x2Scale = createAxis(chart.x2D3ScaleType).rangeRound([chart.height, 0])
    var y1Scale = createAxis(chart.y1D3ScaleType).range([chart.height, 0])
    //color
    var metric1ColorScale = d3.scaleOrdinal().range(chart.vizSpecific7.colorScheme)
    //Axises
    var x1AxisLabel = d3.axisBottom(x1Scale)
    var y1AxisLabel = d3.axisLeft(y1Scale).tickFormat(numberFormat)

    console.log("x1scale",chart.x1D3ScaleType);
    console.log("x2scale",chart.x2D3ScaleType);
    console.log("y1scale",chart.y1D3ScaleType);

    var svg = d3.select(divId).select("svg").remove();

    /* function make_x_gridlines(x) {
        return d3.axisBottom(x)
            .ticks(5)
    }

    // gridlines in y axis function
   function make_y_gridlines(y) {
        return d3.axisLeft(y)
            .ticks(5)
   }*/

    svg = d3.select(divId).append('svg')
        .attr('width', chart.width + chart.margin.left + chart.margin.right)
        .attr('height', chart.height + 3 * chart.margin.top + 3 * chart.margin.bottom)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')')

    // axios.post(url, filterParam).then(res => {
    let data =resData
    var categories = d3.keys(data[0]).filter(function (key) {
        return key === 'metric1' || key === 'metric2' || key === 'metric3' || key === 'metric4' || key == "metric5"
    })

    data.forEach(function (d) {
        //first calculate the starting height for each category
        let total, totals;
        total = 0
        totals = {}
        for (var i = 0; i < categories.length; i++) {
            if (i >= chart.vizSpecific1) {
                total = total - +d[categories[i]]
                totals[categories[i]] = total
            } else {
                totals[categories[i]] = total
                total += +d[categories[i]]
            }
        }
        //then map category name, value, and starting height to each observation
        d.formatted = categories.map(function (category) {
            return {
                name: category,
                value: +d[category],
                baseHeight: +totals[category]
            }
        })
    })

    x1Scale.domain(data.map((d) => {
        return d.dim1_name
    }))
    x2Scale.domain(categories).range([0, x1Scale.bandwidth()])
    y1Scale.domain([0, d3.max(data, function (d) {
        return d3.max(d.formatted, function (d) {
            return d.value + d.baseHeight
        })
    })])

    /*d3.select(".d3-tipwater"+divId.id).remove(); // clear tooltip based on class of tip element
    var y1tip = tooltip_class()

    y1tip.attr('class', 'd3-tip'+divId.id) // why different names? what is the implication
          .offset([-10, 0])
          .html(function (d) {
            return d.name  == "metric1" ? chart.vizSpecific5+ colonAnnotation+ numberFormat(d.value):
                   d.name == "metric2" ? chart.x1DataFieldName+ colonAnnotation+ numberFormat(d.value):
                   d.name == "metric3" ? chart.x2DataFieldName+ colonAnnotation+ numberFormat(d.value):
                   d.name == "metric4" ? chart.y1DataFieldName+ colonAnnotation+ numberFormat(d.value):
                   d.name == "metric5" ? chart.y2DataFieldName+ colonAnnotation+ numberFormat(d.value):
                   null+ colonAnnotation+ d.value;
          })*/
    // d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
    // var div = d3.select(divId).append('div').attr('class', 'tooltip')
    //     .attr('style', 'position: absolute; opacity: 0;')

    svg.append('g')
        .attr('class', 'x axis')
        .attr('transform', 'translate(0,' + chart.height + ')')
        .call(x1AxisLabel)
        .selectAll('.x.axis .tick line')
        .attr('transform','translate(0'+ x1Scale.bandwidth()/2+')')
        .attr('stroke',0.3)
    svg.selectAll('text')
        .style('font-size', axisLabelFontSize)
        .style('text-anchor', 'end')
        // .attr('dx', '-1em')
        .attr('dy', '.8em')
    // .attr('transform', 'rotate(-50)')

//            Axis label text
    svg.append('text')
        .attr('x', (chart.width / 3))
        .attr('y', chart.height + 3 * chart.margin.bottom + 8 * chart.axisLabelDistance)
        .style('fill', fontColor)
        .text(chart.x1AxisDisplayName)
        .style('font-size', fontSize)

    svg.append('text')
        .attr('transform', 'rotate(-90)')
        .attr('y', 0 - chart.margin.left + chart.axisLabelDistance)
        .attr('x', 0 - (chart.height / 2))
        .attr('dy', '1em')
        .style('text-anchor', 'middle')
        .style('fill', fontColor)
        .text(chart.y1AxisDisplayName)
        .style('font-size', fontSize)

    svg.append('g').attr('class', 'y axis').call(y1AxisLabel).selectAll('text').style('font-size', axisLabelFontSize)

    const tooltip = createTooltip(divId);

    var state = svg.selectAll('.state')
        .data(data)
        .enter().append('g')
        .attr('class', 'g')
        .attr('transform', (d) => {
            return 'translate(' + x1Scale(d.dim1_name) + ',0)'
        })

    state.selectAll('rect')
        .data(function (d) {
            return d.formatted
        })
        .enter().append('rect')
        .attr('width', x2Scale.bandwidth())
        .attr('x', (d) => {
            return x2Scale(d.name)
        })
        .attr('y', (d) => {
            return y1Scale(d.value + d.baseHeight)
        })
        .attr('height', (d) => {
            return chart.height - y1Scale(d.value)
        })
        .style('fill', (d) => {
            return metric1ColorScale(d.name)
        })
        .on('mouseover', function( d) {
            tooltip.onMouseOver(d, this, function(d) {
                // Tooltip content callback
                return d.name == "metric1" ? chart.vizSpecific5 + colonAnnotation + numberFormat(d.value) :
                    d.name == "metric2" ? chart.x1DataFieldName + colonAnnotation + numberFormat(d.value) :
                        d.name == "metric3" ? chart.x2DataFieldName + colonAnnotation + numberFormat(d.value) :
                            d.name == "metric4" ? chart.y1DataFieldName + colonAnnotation + numberFormat(d.value) :
                                d.name == "metric5" ? chart.y2DataFieldName + colonAnnotation + numberFormat(d.value) :
                                    null + colonAnnotation + d.value
            });  // Pass the event for positioning
        })
        .on('mousemove', function(event) {
            tooltip.onMouseMove(event);  // Update tooltip position on mouse move
        })
        .on('mouseout', function() {
            tooltip.onMouseLeave();  // Hide the tooltip on mouse leave
        })
        .on('contextmenu', function(d) {
// Get parent group data (contains x-axis tick value)
            const parentData = d3.select(this.parentNode).datum();

            // Prepare clickedData with both axes' info
            const clickedData = {
                [chart.insightNavigator.realDataFieldNames.x1RealDataFieldName]: [parentData.dim1_name]
            };
            console.log("clickedData", clickedData,d);
            // Generate the menu with current config and filters
            const menuItems = generateDownloadData(chart.insightNavigator.navList, filterParam);

            // Show the context menu
            contextMenu(menuItems).call(this, clickedData);

            // Prevent default context menu
            d3.event.preventDefault();
        }); //commented due to hardcoding

    //Bar Separator Line
    state.append("line")
        .attr("class", "bar_separater")
        .attr("x1", (x1Scale.step() - x1Scale.bandwidth()) * 0 + x1Scale.bandwidth())
        .attr("x2", (x1Scale.step() - x1Scale.bandwidth()) * 0 + x1Scale.bandwidth())
        .attr("y1", 0)
        .attr("y2", chart.height + (chart.margin.bottom / 2))//+ chart.margin.top + chart.margin.bottom)
        .style("stroke-width", 0.3)
        .style("stroke", "#000");

    //svg.call(y1tip);

    var toggle = true;

    d3.select("#" + divId.id + "grid").on("click", function gridToggle() {
        d3.selectAll("line").style("opacity", +(toggle = !toggle))
    })

    var y1legend = svg.selectAll('.legend')
        .data(categories)
        .enter()
        .append('g')
        .attr('class', 'legend')
        .attr('transform', function (d, i) {                     // NEW
            //  var height = 0;          // NEW
            var horz = 180 * i;                       // NEW
            var vert = 6;                        // NEW
            return 'translate(' + horz + ',' + vert + ')';        // NEW
        });

    y1legend.append('rect')
        .attr('x', (chart.width / 7))
        .attr('y', chart.height + 2 * chart.margin.bottom)
        .attr('width', 20)
        .attr('height', 20)
        .style('fill', metric1ColorScale)

    y1legend.append('text')
        .attr('x', (chart.width / 7) + 20)
        .attr('y', chart.height + 2 * chart.margin.bottom)
        .attr('dy', '1em')
        .style('font-size', '14px')
        //  .style('text-anchor', 'end')
        .text(function (d) {
            return d == "metric1" ? chart.vizSpecific5 :
                d == "metric2" ? chart.x1DataFieldName :
                    d == "metric3" ? chart.x2DataFieldName :
                        d == "metric4" ? chart.y1DataFieldName :
                            d == "metric5" ? chart.y2DataFieldName : null
        })
    // })
}
